import React, { useEffect, useState } from "react"
import ProgressBar from "@ramonak/react-progress-bar"

import logoIcon from "../../../assets/images/logo-icon.svg"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { formatAmount } from "helpers/common"
import AdminOffersCardsSk from "components/Skeltons/dashboard/AdminOffersCardsSk"
import { useLazyGetAdminOffersQuery } from "store/api/reports/reports"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import moment from "moment"

const defaultFilters = {
  search: "",
  page: 1,
  created_by: "ADMIN",
  pageSize: 20,
}

const AdminOffersCards = () => {
  const { currentUserMenuType } = useSelector((state) => state.common)
  const [getResults, { isFetching }] = useLazyGetAdminOffersQuery()
  const [data, setData] = useState([])
  const [activeVisibleIndex, setActiveVisibleIndex] = useState(0)

  const getList = async () => {
    try {
      const { data } = await getResults(defaultFilters).unwrap()
      setData(data)
    } catch (e) { }
  }

  useEffect(() => {
    getList()
  }, [defaultFilters])

  return (
    <React.Fragment>
      <div className="icd-card-wrapper-section">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          navigation={false}
          watchSlidesProgress={true}
          // pagination={{ clickable: false }}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={false}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 1.7 },
            1400: { slidesPerView: 2 },
          }}
          onTransitionEnd={(swiper) => {
            if (swiper.visibleSlides?.length) {
              setActiveVisibleIndex(swiper.visibleSlides[0].swiperSlideIndex)
            }
          }}
        >
          {isFetching && data.length <= 0 ? (
            <AdminOffersCardsSk />
          ) : (
            <>
              {data.map((item, index) => (
                <SwiperSlide key={`admin_icds_${index}`}>
                  <Link to={`/icd/offers/${item.id}`}>
                    <div
                      className={`${index === activeVisibleIndex ? `icd-card-box ${currentUserMenuType === "WEALTH_PARTNER" ? "wealth-patner-box" : ""} ` : "icd-card-box-second"}`}
                    >
                      <div className="logo-section-wrapper">
                        <div className="logo-image">
                          <img src={logoIcon} alt="" />
                        </div>
                        <h4>{item.unique_code}</h4>
                      </div>
                      <h5>₹ {formatAmount(item.total_invested_amount)}</h5>
                      <div>
                        <ProgressBar
                          borderRadius="8px"
                          height="8px"
                          baseBgColor={index === activeVisibleIndex ? "#FFFFFF33" : "#B3B3B333"}
                          bgColor={
                            index === activeVisibleIndex
                              ? currentUserMenuType === "WEALTH_PARTNER"
                                ? "#FFFFFF"
                                : "#F0A735"
                              : currentUserMenuType === "WEALTH_PARTNER"
                                ? "#F0A634"
                                : "#1667AD"
                          }
                          completed={
                            item.total_invested_amount > 0
                              ? Math.max(
                                (item.total_invested_amount / item.amount) *
                                100,
                                0
                              )
                              : 0
                          }
                          isLabelVisible={false}
                        />
                      </div>
                      <div className="amount-wrapper">
                        <div className="left-box">
                          <p>
                            Total Amt <span>₹ {formatAmount(item.amount)}</span>
                          </p>
                        </div>
                        <div className="right-box">
                          <p>
                            Req. Amt{" "}
                            <span>
                              ₹{" "}
                              {formatAmount(
                                item.amount - item.total_invested_amount
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="offer-card-roi-wrapper">
                        <p>
                          ROI <span>{item.interest_rate}% p.a</span>
                        </p>
                        |
                        <p>
                          Fund Req.{" "}
                          <span>
                            {moment(item.fund_requirement_date).format(
                              "DD-MM-YYYY"
                            )}
                          </span>
                        </p>
                        |
                        <p>
                          Maturity{" "}
                          <span>
                            {moment(item.repayment_date).format("DD-MM-YYYY")}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </>
          )}
        </Swiper>
      </div>
    </React.Fragment>
  )
}

export default AdminOffersCards
